import {Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges} from '@angular/core';
import {EChartsOption} from 'echarts';
import {
  DEFAULT_GAUGE_PALETTE,
  DetailsChartGaugeColor,
  DetailsChartsDto,
  IconType,
  IoniconsOutline,
  ND
} from '@pt/pt-models';

@Component({
  selector: 'pt-required-reload',
  template: `
    <div class="required-reload" *ngIf='requiredReload'>
      <pt-icon
        (click)='reload.emit()'
        [key]='iconReload'
        [size]='18'
        class='dc-recalculate-button'
        container='body'
        ngbTooltip="{{'BUTTON.RECALCULATE' | translate}}"
      ></pt-icon>
    </div>

  `,
  styles: [`
    .required-reload {
      width: 100%;
      height: 100%;
      z-index: 1;
      position: absolute;
      left: 0;
      top: 0;
      background: #93928f3b;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 3px;
    }
    .dc-recalculate-button {
      display: flex;
      cursor: pointer;
      color: #000000;
    }

    .dc-recalculate-button:hover {
      color: #737373;
    }
  `]
})
export class RequiredReloadComponent {
  @Input() requiredReload: boolean;
  @Output() reload = new EventEmitter<boolean>();
  iconReload = IoniconsOutline.reload;

}
